<template>
  <div class="view-260">
    <div class="text-45 poppins-normal-storm-dust-14px">4ч 30мин</div>
    <img
      class="vector-216"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-75.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "View332",
};
</script>

<style>
.view-260,
.view-268,
.view-269,
.view-261,
.view-262,
.view-263,
.view-264,
.view-265,
.view-266,
.view-267 {
  height: 25px;
  position: relative;
  width: 102.22px;
}

.text-45,
.text-484,
.text-635,
.text-7-2,
.text-46,
.text-1-11,
.text-1-12,
.text-14-3,
.text-17-3,
.text-19-2 {
  left: 31px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.vector-216,
.vector-224,
.vector-225,
.vector-217,
.vector-218,
.vector-219,
.vector-220,
.vector-221,
.vector-222,
.vector-223 {
  height: 96.88%;
  left: 0;
  position: absolute;
  top: 0;
  width: 23.69%;
}
</style>
